<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
      :loading="false"
  >
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <div v-if="!isSenakponTenant"  class="card shadow-sm pt-5 px-5">
          <h1 class="mb-10 text-center text-uppercase fs-2hx">{{ $t('events.select_type_form') }}</h1>
          <div class="d-flex flex-wrap justify-content-center">
            <div v-for="(form, index) in event?.forms" :key="index" class="col-auto mb-5 d-flex justify-content-center align-items-center p-5 me-5 text-uppercase rounded-2 bg-hover-primary text-hover-white fw-bold form_style" :class="form.id == formId ? 'bg-primary text-white' : 'bg-light-primary text-primary'" @click="setType(form.id)">
              {{form.name}}
            </div>
          </div>
        </div>
        <div v-if="!isSenakponTenant" class="mt-10">
          <FormPreview v-if="formId" :steps="formValue?.form?.steps" :eventName="event?.title" @close="goHome" :formId="formId" :note="formValue?.note"/>
        </div>
        <div class="mt-10 px-15" v-if="isSenakponTenant">
          <GoogleFormPreview :event="event?.id" @close="goHome"/>
        </div>
      </Loader>
    </template>
  </SubLayout> 
</template>

<script setup>
  import { ref, onMounted, watch } from "vue"; 
  import {useStore} from "vuex";
  import {useRoute, useRouter} from "vue-router";
  import FormPreview from "../../components/FormPreview.vue";
  import GoogleFormPreview from "../../components/GoogleFormPreview.vue";
  import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
  import Loader from "@/components/Loader.vue";
import { getTenantId } from "@/mixins/Helpers";

  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  const event = ref({})
  const formValue = ref([])
  const formId = ref('')

  const title = ref( "events.title")
  const breadcrumbs = ref([])
  const isLoading = ref(false)
  const isSenakponTenant = ref(false)


  watch(() => formId.value, (value) => {
    if(value){
      showFormData()
    }
  }, { deep: true });

  function setType(item) {
    formId.value = item
  }

  async function showEvent() {
      await store.dispatch('events/getEventDetailForParticipator', route.params.id).then((res) => {
        event.value = res.data?.data
      })
  }

  async function showFormData() {
    await store.dispatch('forms/getEventFormsForParticipator', formId.value).then((res) => {
        formValue.value = res.data?.data
    })
  }

  function goHome() {
    router.go(-1)
  }

  onMounted(() => {
    showEvent()
    isSenakponTenant.value = getTenantId()?.slice(0, -1).toLowerCase() === 'senakpon'
  })
</script>

<style scoped>
  .text-gray {
    color: var(--bs-gray);
  }
  .center_vertical {
    width: 80%;
    margin: 0 auto !important;
    padding-top: 3rem;
  }

  .chat_fixed {
    position: fixed;
    right: 2rem;
    bottom: 7rem;
    cursor: pointer !important;
  }

  .form_fixed {
    position: fixed;
    right: 2rem;
    bottom: 11rem;
    width: 300px; 
    height: 350px;
  }

  .italic-text {
    font-style: italic;
  }

  .btn.btn-orange {
    color: #fff;
    border-color: var(--bs-warning) !important;
    background-color: var(--bs-warning) !important;
  }

  .single-digit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    background-color: rgba(0, 33, 119, 0.3);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    min-width: 90px !important;
    height: 100px !important;
    position: relative;
  }

  .time-label {
    font-size: 12px !important;
    line-height: 1;
    margin-top: 5px;
    font-weight: 500;
  }

  .time-number {
    font-size: 50px !important;
    line-height: 1;
    font-weight: 500;
  }

  .h1_style {
    font-size: 75px !important; 
    margin-bottom: 2rem;
  }

  .p_style {
    font-size: 20px !important; 
    width: 90% !important;
  }

  .span_style {
    font-size: 10px !important; 
    width: 88% !important;
    margin-bottom: 2rem; 
    cursor: pointer;
    margin-right: 5rem !important;
  }

  .timer {
    width: 200px !important; 
    margin-bottom: 8rem;
  }

  .fs-18 {
    font-size: 18px !important;
  }

  .address {
    margin-bottom: 3rem; 
    display: flex;
  }

  .img_top {
    width: 60px; 
    height: 60px; 
    border-radius: 1rem; 
    margin-bottom: 2rem;
  }

  .img_top img {
    width: 42px;
  }

  .truncate-text {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .background-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .background-container::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 33, 119, 0.45);
    z-index: 0;
  }

  .background-container > * {
    position: relative;
    z-index: 1;
  }

  .form_style {
    font-size: 13px !important;
    cursor: pointer !important; 
    width: 350px !important;
  }

  @media (max-width: 768px) {
    .center_vertical {
      padding-top: 1.5rem !important;
    }

    .h1_style {
      font-size: 30px !important; 
    }

    .p_style {
      font-size: 15px !important;
      width: 100% !important;
    }

    .span_style {
      font-size: 10px !important; 
      width: 100% !important;
    }

    .timer {
      width: 100px !important; 
    }

    .single-digit {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      background-color: rgba(0, 33, 119, 0.3);
      border-radius: 5px;
      padding: 5px;
      color: #fff;
      min-width: 60px !important;
      height: 80px !important;
      position: relative;
    }

    .time-label {
      font-size: 9px !important;
      line-height: 1;
      margin-top: 5px;
    }

    .time-number {
      font-size: 30px !important;
      line-height: 1;
    }

    .fs-18 {
      font-size: 12px !important;
    }

    .address {
      display: block;
    }

    .address .fs-18 {
      font-size: 15px !important;
    }

    .img_top {
      width: 40px; 
      height: 40px; 
      border-radius: 1rem; 
    }

    .img_top img {
      width: 25px;
    }

    .form_style {
      font-size: 10px !important;
      width: 300px !important;
    }
  }
</style>
<script setup lang="ts">
</script>